"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVideoLibFrontendVars = void 0;
var constantsPerEnvironment_1 = require("./constantsPerEnvironment");
Object.defineProperty(exports, "getVideoLibFrontendVars", { enumerable: true, get: function () { return constantsPerEnvironment_1.getVideoLibFrontendVars; } });
//# sourceMappingURL=index.js.map